import React, { useState } from "react";
import { addSubscription } from "./subscriptionApi";

import "../static/style.css";
const SubscriptionForm = () => {
  const [form, setForm] = useState({ name: "", email: "" });
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      await addSubscription(form);
      setMessage("Thank you for subscribing!");
      setForm({ name: "", email: "" });
    } catch (e) {
      setMessage("Subscription failed. Please try again.");
    }
    setLoading(false);
  };

  return (
    <form className="subscription-form vertical" onSubmit={handleSubmit} style={{ marginTop: 8 }}>



      <input
        name="name"
        type="text"
        placeholder="Your Name"
        value={form.name}
        onChange={handleChange}
        required
        className="input subscription-form-input-style"
        style={{ marginBottom: 4 }}
      />
      <input
        name="email"
        type="email"
        placeholder="Your Email"
        value={form.email}
        onChange={handleChange}
        required
        className="input subscription-form-input-style"
        style={{ marginBottom: 4 }}
      />
      <button type="submit" className="btn-primary-primary" disabled={loading} style={{ width: '100%' }}>
        {loading ? "Subscribing..." : "Subscribe"}
      </button>
      {message && <div style={{ marginTop: 6, color: message.startsWith('Thank') ? 'white' : 'red' }}>{message}</div>}
    </form>
  );
};

export default SubscriptionForm;
